import { NumericFormat, NumericFormatProps } from "react-number-format";
import { felixTokens } from "../../../../theme";

export default function PercentualText(props: NumericFormatProps) {
  const { value, ...other } = props;

  return (
    <NumericFormat
      value={(value as number) * 100}
      displayType={"text"}
      suffix={"%"}
      thousandSeparator=""
      decimalSeparator=","
      decimalScale={0}
      valueIsNumericString
      // Percentual é número comparado em coluna: mono tabular.
      style={{
        fontFamily: felixTokens.fontMono,
        fontVariantNumeric: "tabular-nums",
      }}
      {...other}
    />
  );
}
